import type { CountryCode } from '@gql/graphql';
import type { LocationDescriptor } from 'history';
import type { MouseEventHandler } from 'react';

export interface JoinBreederPageFormValues {
  firstName: string;
  lastName: string;
  email: string;
  phonePrefixCountry: string;
  phoneNumber: string;
  country: CountryCode;
  password: string;
  confirmPassword: string;
  acceptedChart: boolean;
  acceptedTerms: boolean;
}

export interface JoinBreederPageData {
  loginLink: LocationDescriptor;
  onSubmitClick: MouseEventHandler;
  loading?: boolean;
}

export interface JoinBreederPageProps extends JoinBreederPageData {}
